import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Header } from '@masfront/common-b2c'

import { LogoutModal } from '~/auth/components/LogoutModal'
import { selectAgent } from '~/auth/store/auth.selectors'
import { useBrand, getThemeName, getBrandFromThemeName } from '~/brand'
import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'
import { resetAction } from '~/core/store/app.reducer'
import InputDocumentType from '~/header/components/InputDocumentType/InputDocumentType'
import { PATHS, SALES_PATHS } from '~/pages/router/paths'
import Permission from '~/permissions/model/permissions.model'
import { selectHasPermission } from '~/permissions/store/permissions.selectors'

interface HeaderContainerProps {
  permissions?: Permission[]
}

const HeaderContainer: React.FC<HeaderContainerProps> = ({ permissions }) => {
  const { brand } = useBrand()
  const history = useHistory()
  const dispatch = useDispatch()
  const { agent } = useSelector(selectAgent)

  const { runtimeConfig } = useAppDepsContext()

  function onChangeBrand(themeName: string) {
    history.push({
      pathname: `/${PATHS.CUSTOMER}`,
      search: `?brand=${getBrandFromThemeName(themeName)}`,
    })
    dispatch(resetAction())
  }

  const [logoutOpen, setLogoutOpen] = useState(false)

  function onLogout() {
    setLogoutOpen(true)
  }

  function onCloseLogoutModal() {
    setLogoutOpen(false)
  }

  const hasPermissions = !!permissions?.length
  const hasPermissionSellRecruitment = useSelector(selectHasPermission(Permission.SELL_RECRUITMENT))

  return (
    <Header
      onHandleLogout={onLogout}
      onChangeBrand={onChangeBrand}
      onNewSale={() => null}
      onOpenMenu={() => null}
      title="MasCare"
      agentName={agent?.sub || ''}
      theme={getThemeName(brand)}
      onAddSubscription={() =>
        window.open(`${runtimeConfig.salesHost}${SALES_PATHS.SALES_START}?brand=${brand}`, '_self')
      }
      saleButtons={hasPermissionSellRecruitment}
    >
      <InputDocumentType isLoading={false} disabled={!hasPermissions} />
      {logoutOpen && <LogoutModal open={logoutOpen} onClose={onCloseLogoutModal} />}
    </Header>
  )
}

export default HeaderContainer
